export const licensesDataGuard = () => {
    return true;
};
